import React from 'react';
import { } from '@mui/material';
import IntrinsicInformer from '../components/INFORMER/IntrinsicInformer';
import InformerHerosection from '../components/INFORMER/InformerHerosection';

const ProductInformer = () => {
  

  return (
    <>
      <InformerHerosection />
      <IntrinsicInformer/>

      
    </>
  );
};

export default ProductInformer;